import axios from "axios";
import { useState, useEffect, useCallback } from "react";
import CONFIG from "../constanta/config";
import Cookies from "js-cookie";

const useEvent = () => {
  const fetchData = useCallback(async () => {
    try {
      const response = await axios.get(CONFIG.URL + "/event/gate?limit=1000", {
        headers: {
          token: Cookies.get("token"),
        },
      });

      if (response?.data?.status === "SUCCESS") {
        let localEvent = JSON.stringify(response.data?.data);
        window.localStorage.setItem("LocalEvent", localEvent);
      }
    } catch (error) {}
  }, []);

  return { fetchData };
};

export default useEvent;
